module.exports = __webpack_public_path__ + "img/Random-and-Confirm-min.c1ba2804.png";